import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import { BusinessAttributes } from "../attributes/business-attributes";
import {base64toFile} from "../common/Hooks";
import BaseService from "./BaseService";

export class BusinessService extends BaseService {
  static getById(
    id: number,
    scopes = ""
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().get(`businesses/${id}`, {
      params: { scopes: scopes },
    });
  }

  static declineBusiness(
    businessId: number,
    comment: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().post(
      `admin/businesses/${businessId}/decline`,
      {
        comment: comment
      }
    );
  }

  static approveBusiness(
    businessId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().put(
      `admin/businesses/${businessId}/approve`
    );
  }

  static businessTeam(
    businessId: number,
    page: number,
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().get(
      `admin/businesses/${businessId}/team`,
        {
          page: page
        }
    );
  }

  static async searchByName(
    query: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = "businesses/search";

    return BusinessService.getPublicApiClient().get(url, {
      params: { query: query },
    });
  }

  static async registerBusiness(
    data: BusinessAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      if (
        "registration_photo" !== key.toString() &&
        "tax_payer_photo" !== key.toString() &&
        "id_bank_photo" !== key.toString() &&
        "company_logo" !== key.toString()
      ) {
        formData.append(key, data[key]);
      }
    });

    // Add file data registration photo
    if (data.registration_photo) {
      formData.append(
        "registration_photo",
        base64toFile(data.registration_photo, "registration_photo.png")
      );
    }

    // Add file data tax payer photo
    if (data.tax_payer_photo) {
      formData.append(
        "tax_payer_photo",
        base64toFile(data.tax_payer_photo, "tax_payer_photo.png")
      );
    }

    // Add file data Id bank photo
    if (data.id_bank_photo) {
      formData.append(
        "id_bank_photo",
        base64toFile(data.id_bank_photo, "id_bank_photo.png")
      );
    }

    // Add file data company logo
    if (data.company_logo) {
      formData.append(
        "company_logo",
        base64toFile(data.company_logo, "company_logo.png")
      );
    }

    return BusinessService.getApiClient().sendFormData({
      method: "post",
      url: "businesses/create",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static moreInfo(
    businessId: number,
    comment: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().post(
      `admin/businesses/${businessId}/moreinfo`,
      {
        comment: comment
      }
    );
  }

  static async updateBusiness(
      id: number,
    data: BusinessAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      if (
        "registration_photo" !== key.toString() &&
        "tax_payer_photo" !== key.toString() &&
        "id_bank_photo" !== key.toString() &&
        "company_logo" !== key.toString()
      ) {
        formData.append(key, data[key]);
      }
    });

    // Add file data registration photo
    if (
      data.registration_photo !== null &&
      data.registration_photo !== undefined &&
      typeof data.registration_photo !== typeof ""
    ) {
      formData.append(
        "registration_photo",
        base64toFile(data.registration_photo, "registration_photo.png")
      );
    }

    // Add file data tax payer photo
    if (
      data.tax_payer_photo !== null &&
      data.tax_payer_photo !== undefined &&
      typeof data.tax_payer_photo !== typeof ""
    ) {
      formData.append(
        "tax_payer_photo",
        base64toFile(data.tax_payer_photo, "tax_payer_photo.png")
      );
    }

    // Add file data Id bank photo
    if (
      data.id_bank_photo !== null &&
      data.id_bank_photo !== undefined &&
      typeof data.id_bank_photo !== typeof ""
    ) {
      formData.append(
        "id_bank_photo",
        base64toFile(data.id_bank_photo, "id_bank_photo.png")
      );
    }

    // Add file data company logo
    if (
      data.company_logo !== null &&
      data.company_logo !== undefined &&
      typeof data.company_logo !== typeof ""
    ) {
      formData.append(
        "company_logo",
        base64toFile(data.company_logo, "company_logo.png")
      );
    }

    return BusinessService.getApiClient().sendFormData({
      method: "post",
      url: `businesses/${id}/update`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static getAllbusinesses(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().get(`admin/businesses`);
  }

  static async businessWithdrawRequest(
    businessId: number,
    walletType: number,
    amount: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().post(`businesses/withdraw-request/add`, {
      business_id: businessId,
      wallet_type: walletType,
      amount: amount,
    });
  }

  static businessWithdrawRequestList(
    businessId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().post(`businesses/withdraw-request/list`, {
      business_id: businessId
    });
  }

  static getWithdrawCost(
    amount: number,
    businessId: number,
    accountId: number,
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().post(`businesses/withdraw-request/cost`, {
      amount: amount,
      business_id: businessId,
      account_id: accountId
    });
  }

  static activities(
      userId: number,
      page: number | null,
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessService.getApiClient().get(`admin/businesses/${userId}/activities`, {
      "page": page
    });
  }
}

export default BusinessService;
